import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Divider as MuiDivider,
} from '@mui/material';
import {
  Assessment as AssessmentIcon,
  CalendarToday as CalendarIcon,
  TrendingUp as TrendingUpIcon,
} from '@mui/icons-material';

function SectorDataStatsCard({ dataStatistics }) {
  const { t } = useTranslation();
  return (
    <Card
      elevation={0}
      sx={{
        flex: 1,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 0.5,
      }}
    >
      <CardContent sx={{ p: 2.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
          <AssessmentIcon sx={{ color: 'info.main', mr: 1, fontSize: 18 }} />
          <Typography variant="subtitle2" sx={{ fontWeight: 600, fontSize: '0.875rem', letterSpacing: '0.01em', color: 'text.primary' }}>
            {t('sectorsManagement.details.dataStatistics.title')}
          </Typography>
        </Box>
        <MuiDivider sx={{ mb: 2.5, opacity: 0.2 }} />
        <Grid container spacing={2.5}>
          <Grid item xs={12}>
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem', mb: 0.75, display: 'block', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              {t('sectorsManagement.details.dataStatistics.totalDays')}
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.375rem', color: 'text.primary', letterSpacing: '-0.01em' }}>
              {dataStatistics?.total_days || 0}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.75 }}>
              <CalendarIcon sx={{ fontSize: 13, color: 'text.secondary', opacity: 0.6 }} />
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                {t('sectorsManagement.details.dataStatistics.firstDate')}
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ fontWeight: 400, fontSize: '0.875rem', color: 'text.primary', ml: 2.25, fontFamily: 'monospace', letterSpacing: '0.02em' }}>
              {dataStatistics?.first_date || '-'}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.75 }}>
              <TrendingUpIcon sx={{ fontSize: 13, color: 'text.secondary', opacity: 0.6 }} />
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                {t('sectorsManagement.details.dataStatistics.latestDate')}
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ fontWeight: 400, fontSize: '0.875rem', color: 'text.primary', ml: 2.25, fontFamily: 'monospace', letterSpacing: '0.02em' }}>
              {dataStatistics?.latest_date || '-'}
            </Typography>
          </Grid>
          {dataStatistics?.avg_close && (
            <Grid item xs={12}>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem', mb: 0.75, display: 'block', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                {t('sectorsManagement.details.dataStatistics.avgPrice')}
              </Typography>
              <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.375rem', color: 'text.primary', letterSpacing: '-0.01em' }}>
                {dataStatistics.avg_close.toLocaleString('vi-VN', { maximumFractionDigits: 2 })}
              </Typography>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
}

export default SectorDataStatsCard;

